export default __webpack_public_path__ + "static/media/FISH.d224bee9.svg";